import React from 'react';
import {useSignOut} from "react-auth-kit";
import {useNavigate} from "react-router-dom";


export default function SignOut() {
    const signOut = useSignOut()
    const navigate = useNavigate()

    signOut()
    navigate('/admin_area/signin')

}

